<template>
    <div class="container">
        <div class="back" @click="goBack"><i class="el-icon-back"></i> 返回</div>

        <el-alert class="notice" type="info" :closable="false" show-icon
            title="用于客服补偿与测试开通。操作人由服务端从登录态自动取（姓名+管理员ID）写进订单描述，前端不用传。开通只校验套餐编号存在，不校验套餐状态 / 区域 / 型号白名单。">
        </el-alert>

        <h4 class="section-title">后台开通套餐</h4>
        <el-form ref="openForm" :model="openForm" :rules="openRules" label-width="140px" class="cloudinfo-form">
            <el-form-item label="目标用户 uid" prop="uid">
                <el-input v-model.trim="openForm.uid" maxlength="64" placeholder="请输入目标用户 uid"></el-input>
            </el-form-item>
            <el-form-item label="目标设备 uuid" prop="uuid">
                <el-input v-model.trim="openForm.uuid" maxlength="64" placeholder="请输入目标设备 uuid"></el-input>
            </el-form-item>
            <el-form-item label="套餐" prop="package_code">
                <el-select v-model="openForm.package_code" filterable placeholder="请选择套餐" style="width: 480px">
                    <el-option v-for="item in packageOptions" :key="item.code"
                        :label="item.name + '（' + item.code + '）'" :value="item.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="开通周期数">
                <el-input-number v-model="openForm.cycle" :min="1" :max="120" :precision="0"></el-input-number>
                <span class="help-text">套餐时长的倍数，月度套餐填 2 = 开通 2 个月；上限 120</span>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" :loading="openSaving" @click="submitOpen">开通套餐</el-button>
            </el-form-item>
        </el-form>
        <el-alert v-if="openResult" class="result" type="success" :closable="false" show-icon
            :title="'已开通：' + openResult.package_name + '，' + openResult.cycle + ' 个周期，操作人 ' + openResult.opener"></el-alert>
        <div class="tip">开通落的是免费订单，不创建 Chargebee 订阅，所以开通出来的套餐不会自动续费；时间按「设备当前时间与该设备最大 end_time 取较大者」叠加，不会覆盖原有时长。</div>

        <h4 class="section-title close-title">后台关闭套餐</h4>
        <el-form ref="closeForm" :model="closeForm" :rules="closeRules" label-width="140px" class="cloudinfo-form">
            <el-form-item label="生效记录 ID" prop="id">
                <el-input-number v-model="closeForm.id" :min="1" :precision="0"></el-input-number>
                <span class="help-text">pet_cloud_info.id；目前没有生效记录列表页，可让客服从 App 端套餐详情或直接查库获取</span>
            </el-form-item>
            <el-form-item label="退订方式">
                <el-radio-group v-model="closeForm.exit_order">
                    <el-radio v-for="item in exitOrderOptions" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button type="danger" :loading="closeSaving" @click="submitClose">关闭套餐</el-button>
            </el-form-item>
        </el-form>
        <div class="tip">关闭会把生效记录标记删除并把 end_time 截断到当前时间，权益立即失效。退款场景必须选「同时取消订阅」，否则套餐关了还会继续扣款；取消订阅失败时套餐不会被关闭，可直接重试。</div>

        <el-alert v-if="closeResult" class="result" type="success" :closable="false" show-icon
            :title="'已关闭：记录 ' + closeResult.id + '，操作人 ' + closeResult.opener"></el-alert>
    </div>
</template>

<script>
import api from '../../../axios/pack'
import { EXIT_ORDER_OPTIONS } from './constants'

export default {
    name: 'PetCloudInfoManage',
    data() {
        return {
            exitOrderOptions: EXIT_ORDER_OPTIONS,
            packageOptions: [],
            openForm: { uid: '', uuid: '', package_code: '', cycle: 1 },
            closeForm: { id: null, exit_order: 1 },
            openSaving: false,
            closeSaving: false,
            openResult: null,
            closeResult: null,
            openRules: {
                uid: [{ required: true, message: '请输入目标用户 uid', trigger: 'blur' }],
                uuid: [{ required: true, message: '请输入目标设备 uuid', trigger: 'blur' }],
                package_code: [{ required: true, message: '请选择套餐', trigger: 'change' }]
            },
            closeRules: {
                id: [{ required: true, message: '请输入生效记录 ID', trigger: 'blur' }]
            }
        }
    },
    methods: {
        loadPackages() {
            api.PetPackageList({ page: 1, limit: 200, status: JSON.stringify([0, 1, 2]) }).then(res => {
                if (res.data.code == 200) {
                    this.packageOptions = (res.data.data.data || []).filter(item => item && item.code)
                    return
                }
                this.$message.error('获取套餐列表失败：' + res.data.msg)
            })
        },
        submitOpen() {
            this.$refs.openForm.validate(valid => {
                if (!valid) return
                this.openResult = null
                this.openSaving = true
                api.PetCloudInfoOpen({
                    uid: this.openForm.uid,
                    uuid: this.openForm.uuid,
                    package_code: this.openForm.package_code,
                    cycle: Number(this.openForm.cycle)
                }).then(res => {
                    if (res.data.code == 200) {
                        this.openResult = res.data.data || {}
                        this.$message.success('套餐开通成功')
                        return
                    }
                    this.$message.error('开通失败：' + res.data.msg)
                }).finally(() => {
                    this.openSaving = false
                })
            })
        },
        submitClose() {
            this.$refs.closeForm.validate(valid => {
                if (!valid) return
                const tip = this.closeForm.exit_order === 1
                    ? '将关闭记录 ' + this.closeForm.id + ' 并同时取消 Chargebee 订阅，权益立即失效，确定继续?'
                    : '只关闭本地套餐，Chargebee 订阅会继续扣款，确定继续?'
                this.$confirm(tip, '提示', { type: 'warning' }).then(() => {
                    this.closeResult = null
                    this.closeSaving = true
                    api.PetCloudInfoShutdown({
                        id: Number(this.closeForm.id),
                        exit_order: this.closeForm.exit_order
                    }).then(res => {
                        if (res.data.code == 200) {
                            this.closeResult = res.data.data || {}
                            this.$message.success('套餐关闭成功')
                            return
                        }
                        this.$message.error('关闭失败：' + res.data.msg)
                    }).finally(() => {
                        this.closeSaving = false
                    })
                }).catch(() => {})
            })
        },
        goBack() {
            this.$router.push('/iot/petpack')
        }
    },
    created() {
        this.loadPackages()
    }
}
</script>

<style scoped>
.back { display: inline-flex; align-items: center; gap: 4px; margin-bottom: 16px; color: #606266; cursor: pointer; font-size: 14px; }
.back:hover { color: #409eff; }
.notice { margin-bottom: 8px; }
.cloudinfo-form { max-width: 900px; }
.section-title { margin: 20px 0 12px; color: #303133; font-size: 14px; }
.close-title { margin-top: 36px; }
.help-text { margin-left: 10px; color: #909399; font-size: 12px; }
.tip { max-width: 900px; margin-top: 8px; color: #909399; font-size: 12px; line-height: 1.6; }
.result { max-width: 900px; margin-top: 12px; }
</style>
